import { RegisterModule } from '@/typings/common'
import {
  PublicationStorageFileHistoryState,
  PublicationStorageFileHistoryGetters,
  PublicationStorageFileHistoryMutations,
  PublicationStorageFileHistoryActions,
} from './store'
import {
  createMapper,
  registerModule as vuexRegisterModule,
  Module,
} from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: PublicationStorageFileHistoryState,
    getters: PublicationStorageFileHistoryGetters,
    mutations: PublicationStorageFileHistoryMutations,
    actions: PublicationStorageFileHistoryActions,
  })
)

const storeMapper = createMapper(storeModule)

export {
  storeMapper as publicationStorageFilesHistoryStoreMapper,
  storeModule as publicationStorageFilesHistoryStoreModule,
}


export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
